//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useCallback, useEffect, useState, } from 'react';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';

// === COMPONENTS ===
import { useFile } from '../FileContext/FileContext';
import Styled from 'components/Styled/Styled';
import Document from './components/Document/Document';
import { DoctypeProvider } from './components/DoctypeContext/DoctypeContext';

// === API ===
import { on, removeListener, sendMessageData } from 'api/prokey/prokey.websocket';

//#endregion

const DocumentMemo = React.memo( Document );

//-----------------------------------------------------------------
export function DocumentReview( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { is_comp } = props;

  const theme = useTheme();

  const { file_id, is_loading } = useFile();
  
  const [ documents, setDocuments ] = useState(null);

  //#endregion

  //#region [STYLES]

  const scrollbar_thin = {
    // scrollbarColor : `${theme.palette.primary.main} ${theme.palette.background.secondary[theme.palette.mode]}`,
    scrollbarWidth : 'thin'
  }

  //#endregion
    
  //#region [EFFECT]
  
  useEffect( () => {
    if( is_loading ) return;

    const DOCUMENTS = is_comp ? 'FILE_COMPARISON_DOCUMENTS' : 'FILE_DOCUMENTS';

    //-----------------------------------------------------------------
    function handleDocuments( data ) {
      //-----------------------------------------------------------------
      setDocuments( data );
    }

    on( DOCUMENTS, handleDocuments );

    const request_type = is_comp ? 'FILE_REQUEST_COMPARISON_DOCUMENTS' : 'FILE_REQUEST_DOCUMENTS';
    sendMessageData( request_type, { file_id } );

    return () => {
      removeListener( DOCUMENTS, handleDocuments );
    }
  }, [file_id, is_loading] )

  //#endregion

  //#region [MODIFY]

  //#endregion
  
  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[{ width : '100%' , height : 'calc( 100% )' }, { position : 'static' },{overflow:'auto'}, scrollbar_thin]}>
        <DoctypeProvider>
          {displayDocument()}
        </DoctypeProvider>
      </Styled>
    )
  }

  //-----------------------------------------------------------------
  function displayDocument() {
    //-----------------------------------------------------------------
    if( documents == null ) return null;

    let result = [];
    
    for ( let doc of documents ) {
      result.push( <DocumentMemo key={doc.id} id={doc.id} is_comp={is_comp} /> );
    }

    return result;
  }

  //#endregion

  return display();
}